const mapByExcludingNull = <T, K extends NonNullable<unknown>>(
  items: Iterable<T>,
  itemKey: (item: T) => K | null | undefined
): Map<K, T[]> => {
  const result = new Map<K, T[]>();
  for (const item of items) {
    const key = itemKey(item);
    if (!key) {
      continue;
    }
    const values = result.get(key) ?? [];
    if (!values.length) {
      result.set(key, values);
    }
    values.push(item);
  }
  return result;
};

export { mapByExcludingNull };
